import styled from 'styled-components'

export const Box = styled.div`
    background: ${props => props.color};
    width: ${props => props.size + 'px'};
    height: ${props => props.size + 'px'};
    border-radius: ${props => props.size / 2 + 'px'};
`
